<template>
	<el-container class="page-x" direction="vertical">
		<div class="search-x">
			<div class="search-item">
				<span class="label">供应商</span>
				<el-input
					class="input-box"
					clearable
					v-model.trim="searchBox.providerName"
					placeholder="供应商名称、简称"
				></el-input>
			</div>

			<div class="search-item">
				<span class="label">评价状态</span>
				<el-select v-model="searchBox.status" clearable>
					<el-option
						v-for="item in statusArr"
						:value="item.value"
						:key="item.value"
						:label="item.label"
					></el-option>
				</el-select>
			</div>

			<div class="search-item">
				<span class="label">部门</span>
				<el-select v-model="searchBox.branchId" clearable>
					<el-option
						v-for="item in branchIdList"
						:value="item.value"
						:key="item.value"
						:label="item.label"
					></el-option>
				</el-select>
			</div>

			<div class="search-item">
				<span class="label">评价结论</span>
				<el-select v-model="searchBox.rateResult" clearable>
					<el-option
						v-for="item in rateResultArr"
						:value="item.value"
						:key="item.value"
						:label="item.label"
					></el-option>
				</el-select>
			</div>

			<div class="search-item">
				<span class="label">评价人</span>
				<el-input
					class="input-box"
					clearable
					v-model.trim="searchBox.userName"
					placeholder="评价人"
				></el-input>
			</div>

			<div class="search-item">
				<span class="label">评价时间</span>
				<el-date-picker
					v-model="timeCache.treatmentTime"
					@change="
						(e) => toChangeTime(e, 'rateStartTime', 'rateEndTime')
					"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					value-format="timestamp"
					:default-time="['00:00:00', '23:59:59']"
				>
					<!-- :picker-options="{
						disabledDate(time) {
							return time.getTime() > Date.now();
						}
					}" -->
				</el-date-picker>
			</div>

			<!-- el-button v-auth="'sw_role_index'" v-auth属性展示是否有操作权限-->
			<el-button
				v-auth="'sa_provider_page'"
				type="primary"
				class="search-btn"
				@click="searchData"
				>查询</el-button
			>
			<el-button
				class="search-btn"
				v-auth="'sa_item_page'"
				type="primary"
				@click="() => ($root.showPage = false)"
				>重置</el-button
			>

			<el-button
				class="search-btn"
				v-auth="'sa_provider_export'"
				type="warning"
				@click="exportSupplier"
				>批量导出</el-button
			>
		</div>

		<div class="table-x table-b" ref="tableBox">
			<el-table
				v-loading="loading"
				:data="tableData"
				border
				:height="tableHeight"
				empty-text="未查找到相关供应商"
				class="mb20"
			>
				<el-table-column
					type="index"
					width="120px"
					align="center"
					label="序号"
				/>
				<el-table-column align="center" width="200px" label="评价期间">
					<template slot-scope="scope">
						{{ scope.row.startTime ? handlingTime(scope.row) : "" }}
						<!-- {{ scope.row.startTime +'~'+ scope.row.endTime}} -->
					</template>
				</el-table-column>
				<el-table-column
					prop="providerDto"
					align="center"
					width="160px"
					label="供应商名称（全称）"
				>
					<template slot-scope="scope">
						{{ scope.row.providerDto.providerName }}
					</template>
				</el-table-column>
				<el-table-column width="120px" align="center" label="部门">
					<template slot-scope="scope">
						{{ scope.row.branchId | filterValue(branchIdList) }}
					</template>
				</el-table-column>
				<el-table-column
					prop="timeRate"
					align="center"
					width="120px"
					label="响应时间得分"
				>
					<template slot-scope="scope">
						{{ scope.row.timeRate == 0 ? "-" : scope.row.timeRate }}
					</template>
				</el-table-column>
				<el-table-column
					prop="serviceRate"
					width="120px"
					align="center"
					label="服务质量得分"
				>
					<template slot-scope="scope">
						{{
							scope.row.serviceRate == 0
								? "-"
								: scope.row.serviceRate
						}}
					</template>
				</el-table-column>
				<el-table-column
					prop="attitudeRate"
					width="140px"
					align="center"
					label="服务态度得分"
				>
					<template slot-scope="scope">
						{{
							scope.row.attitudeRate == 0
								? "-"
								: scope.row.attitudeRate
						}}
					</template>
				</el-table-column>
				<el-table-column prop="badRate" align="center" label="扣分">
					<template slot-scope="scope">
						{{ scope.row.status == 0 ? "-" : scope.row.badRate }}
					</template>
				</el-table-column>
				<el-table-column
					prop="badReason"
					align="center"
					width="280px"
					label="扣分原因"
				>
					<template slot-scope="scope">
						{{
							scope.row.badReason == ""
								? "-"
								: scope.row.badReason
						}}
					</template>
				</el-table-column>
				<el-table-column prop="totalRate" align="center" label="总分">
					<template slot-scope="scope">
						{{
							scope.row.totalRate == 0 ? "-" : scope.row.totalRate
						}}
					</template>
				</el-table-column>
				<el-table-column prop="rateResult" align="center" label="结论">
					<template slot-scope="scope">
						{{
							scope.row.rateResult
								| filterValue(
									rateResultArr.concat({
										value: 0,
										label: "-",
									})
								)
						}}
					</template>
				</el-table-column>
				<el-table-column prop="status" align="center" label="评价状态">
					<template slot-scope="scope">
						{{ scope.row.status | filterValue(statusArr) }}
					</template>
				</el-table-column>
				<el-table-column prop="userName" align="center" label="评价人">
					<template slot-scope="scope">
						{{
							scope.row.userName == "" ? "-" : scope.row.userName
						}}
					</template>
				</el-table-column>

				<el-table-column
					prop="rateTime"
					align="center"
					width="180px"
					label="评价时间"
				>
					<template slot-scope="scope">
						{{
							scope.row.rateTime == null
								? "-"
								: scope.row.rateTime
						}}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="180px" align="center">
					<template slot-scope="scope" v-if="scope.row.status < 1">
						<el-button-group>
							<el-button
								v-auth="'sa_service'"
								type="text"
								size="middle"
								class="table-btn"
								@click="goService(scope.row)"
								>立即评价</el-button
							>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 分页部分 -->
		<div class="pagination">
			<el-pagination
				@current-change="handleCurrentChange"
				:current-page="searchBox.pageNo"
				@size-change="handleSizeChange"
				:page-sizes="[10, 50, 100]"
				:page-size="searchBox.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
				background
			>
			</el-pagination>
		</div>

		<!-- 新建、修改、查看弹层 -->
		<el-dialog
			append-to-body
			title="供应商评价"
			:visible.sync="dialogVisibleAdd"
			width="80%"
			:close-on-click-modal="false"
			@close="toCloseDialog"
		>
			<div class="title">供应商信息</div>
			<div class="tipTime">
				<div>供应商名称：{{ formData.providerDto.providerName }}</div>
				<div>
					合同时间：{{
						formData.providerDto.contractStartTime +
						"-" +
						formData.providerDto.contractEndTime
					}}
				</div>
				<div>
					供应商状态：{{
						formData.providerDto.providerStatus == 0
							? "启用"
							: "停用"
					}}
				</div>
			</div>
			<div class="title">评价信息</div>
			<div>
				<p class="tipFont">
					请仔细阅读评分规则，并且按照实际情况给予评分
				</p>
				<p>评分规则</p>
				<p>很好 5分；好 4分；一般 3分；不好 2分；很不好 1分</p>
				<p>扣分规则</p>
				<p>
					1.
					问题处理时效：及时或提前，不扣分；延后三天内扣1分；延后一周内扣4分；严重拖延扣5分。
				</p>
				<p>
					2.
					累计服务问题发生次数（认定为由合作机构责任引起的服务问题或投诉次数）：1次扣1分；2-3次扣3分；3-5次扣4分；5次以上扣5分。
				</p>
				<p>如涉及到扣分，扣分原因必须按照实际填写。</p>
			</div>
			<div class="table-x table-b">
				<el-table
					v-loading="loading"
					border
					:data="[formData]"
					empty-text="未查找到相关供应商评价"
					class="mb20"
				>
					<el-table-column
						width="120px"
						align="center"
						label="评价期间"
					>
						<template slot-scope="scope">
							{{
								formData.startTime ? handlingTime(formData) : ""
							}}
							<!-- {{formData.startTime?formData.startTime +'~'+  formData.endTime:''}} -->
						</template>
					</el-table-column>
					<el-table-column
						align="center"
						width="160px"
						label="供应商名称（全称）"
					>
						<template slot-scope="scope">
							{{ formData.providerDto.providerName }}
						</template>
					</el-table-column>
					<el-table-column width="160px" align="center" label="部门">
						<template slot-scope="scope">
							{{ formData.branchId | filterValue(branchIdList) }}
						</template>
					</el-table-column>
					<el-table-column
						label="响应时间得分"
						width="280px"
						align="center"
					>
						<template slot-scope="scope">
							<el-select
								v-model="formData.timeRate"
								clearable
								placeholder="请选择"
							>
								<el-option
									v-for="item in scoreList"
									:value="item.value"
									:key="item.value"
									:label="item.label"
								></el-option>
							</el-select>
						</template>
					</el-table-column>

					<el-table-column
						label="服务质量得分"
						width="280px"
						align="center"
					>
						<template slot-scope="scope">
							<el-select
								v-model="formData.serviceRate"
								clearable
								placeholder="请选择"
							>
								<el-option
									v-for="item in scoreList"
									:value="item.value"
									:key="item.value"
									:label="item.label"
								></el-option>
							</el-select>
						</template>
					</el-table-column>

					<el-table-column
						label="服务态度得分"
						width="280px"
						align="center"
					>
						<template slot-scope="scope">
							<el-select
								v-model="formData.attitudeRate"
								clearable
								placeholder="请选择"
							>
								<el-option
									v-for="item in scoreList"
									:value="item.value"
									:key="item.value"
									:label="item.label"
								></el-option>
							</el-select>
						</template>
					</el-table-column>

					<el-table-column label="扣分" width="280px" align="center">
						<template slot-scope="scope">
							<el-select
								v-model="formData.badRate"
								clearable
								placeholder="请选择"
							>
								<el-option
									:value="0"
									:key="0"
									label="请选择"
								></el-option>
								<el-option
									v-for="item in [1, 2, 3, 4, 5]"
									:value="item"
									:key="item"
									:label="item"
								></el-option>
							</el-select>
						</template>
					</el-table-column>

					<el-table-column
						label="扣分原因"
						width="240px"
						align="center"
					>
						<template slot-scope="scope">
							<el-input
								v-model.trim="formData.badReason"
								clearable
								show-word-limit
								placeholder="请输入扣分原因，0～200字"
								type="textarea"
								maxlength="200"
							></el-input>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<span slot="footer" class="dialog-footer" v-show="dialogType !== 0">
				<el-button class="search-btn" @click="toCloseDialog"
					>取 消</el-button
				>
				<el-button
					type="primary"
					class="search-btn"
					@click="addSupplier"
					:loading="submitLoading"
					>确定</el-button
				>
			</span>
		</el-dialog>
	</el-container>
</template>

<script>
	import cascader from "@/assets/js/cascader.mixin";
	import getService from "@/mixins/getService.mixin";
	import db from "@/assets/js/localstorage";
	import { mapGetters } from "vuex";
	import { dateFormat } from "@/assets/js/until.js";
	import { branchIdList, scoreList } from "@/assets/js/options";
	import _ from "loadsh";

	export default {
		name: "SupplierManager",
		mixins: [cascader, getService],
		components: {},
		data() {
			return {
				timeCache: {}, // 时间缓存
				searchBox: {
					providerName: "", // 模糊查询
					status: "", // 状态
					pageNo: 1, // 页码
					pageSize: 10,
				},
				scoreList,
				statusArr: [
					{ value: 0, label: "待评价" },
					{ value: 1, label: "完成" },
				],
				rateResultArr: [
					{ value: 1, label: "良好" },
					{ value: 2, label: "改进" },
					{ value: 3, label: "较差" },
				],
				branchIdList,
				total: 0,
				tableHeight: 0,
				loading: false,
				tableData: [],
				dialogVisibleAdd: false, //新建、修改弹层
				dialogType: 1, // 1：新增 2：编辑 0：查看
				formData: {
					id: "",
					providerId: "",
					providerDto: {},
					branchId: "",
					userId: "",
					timeRate: "",
					serviceRate: "",
					attitudeRate: "",
					badRate: "",
					badReason: "",
				},
				providerId: "", // 当前id
				submitLoading: false,
				/**
				 * 批量导入供应商 -- 弹窗相关 **/
				path: process.env.BASE_URL,
				uploadHeader: { token: db.get("ACCESS_TOKEN") }, //上传header
				uploadFile: null, //上传后文件
				uploadAction: "", //提交表单地址
				templateForm: {
					tempFile: "",
				},
				errorData: {},
			};
		},
		created() {
			this.$root.breadList = [
				{ name: "供应商", link: "" },
				{ name: "供应商管理", link: "" },
			];
		},
		mounted() {
			this.$nextTick(() => {
				this.getData(); // 获取供应商列表
				this.uploadAction = this.getApiUrl("postProviderImport");
			});
		},
		computed: {
			...mapGetters(["userName"]),
		},
		filters: {
			filterValue(text, data) {
				return (
					data.find((item) => {
						if (text === item.value) {
							return item;
						}
					})?.label || text
				);
			},
		},
		methods: {
			// 列表时间 重新计算展示格式
			handlingTime(row) {
				let timeStart = _.get(row, "startTime", " ")
					.split(" ")[0]
					.replace(/-/g, "/");
				let timeEnd = _.get(row, "endTime", " ")
					.split(" ")[0]
					.replace(/-/g, "/");

				return timeStart + "～" + timeEnd;
			},
			/**
			 * 窗口改变重新获取高度
			 */
			listenWindow() {
				this.tableHeight = this.$refs.tableBox.offsetHeight;
				window.addEventListener("resize", () => {
					clearTimeout(this.resizeFlag);
					this.resizeFlag = setTimeout(() => {
						try {
							this.tableHeight =
								this.$refs.tableBox.offsetHeight || 0;
						} catch (e) {}
					}, 300);
				});
			},
			getReceive(data) {
				this[data.key] = data.value;
			},

			toChangeTime(val, startName, endName) {
				if (val && val.length) {
					this.searchBox[startName] = val[0];
					this.searchBox[endName] = val[1];
				} else {
					this.searchBox[startName] = "";
					this.searchBox[endName] = "";
				}
			},
			goWebsite(row) {
				this.$router.push({
					name: "WebsiteManager",
					query: {
						id: row.id,
						providerAbbr: row.providerAbbr,
					},
				});
			},
			goService(row) {
				this.dialogVisibleAdd = true;
				this.formData = row;
			},
			searchData() {
				this.searchBox.pageNo = 1;
				this.getData();
				this.clrearTipid();
			},
			getData() {
				this.loading = true;
				let params = Object.assign({}, this.searchBox);
				this.axios
					.get(this.getApiUrl("providerRatePage"), {
						params: params,
					})
					.then((res) => {
						this.loading = false;
						if (res.code === 1) {
							this.tableData = res.data.data || [];
							this.total = res.data.total;

							if (params.providerRateId) {
								this.searchBox.providerName =
									res.data.data[0].providerDto.providerName;
							}
						} else {
							this.$message.warning(res.msg);
						}
						this.listenWindow();
					})
					.catch((err) => {
						this.loading = false;
					});
			},

			// 导出供应商评价
			exportSupplier() {
				let urlPath = this.getApiUrl("postProviderRateExport");
				let date = dateFormat(new Date());
				let query = Object.assign({}, this.searchBox);
				let param = this.$root.optionProcess(
					JSON.parse(JSON.stringify(query))
				);
				delete param.pageNo;
				delete param.pageSize;
				if (param.areaId) delete param.areaId;
				let fileName = `供应商信息表${date.replace(/-/g, "").slice(0, 8)}${
					this.userName
				}`;
				this.$root.exportFile(urlPath, param, fileName);
			},
			handleCurrentChange(val) {
				this.searchBox.pageNo = val;
				this.getData();
			},
			handleSizeChange(val) {
				this.searchBox.pageNo = 1;
				this.searchBox.pageSize = val;
				this.getData();
			},

			addSupplier() {
				if (this.formData.badRate && !this.formData.badReason) {
					this.$message.error("扣分原因 必填");
				} else {
					this.$confirm("确认后，数据无法修改，是否确认提交")
						.then((_) => {
							this.addSupplierFn(
								"postProviderRateEdit",
								this.formData
							);

							done();
						})
						.catch((_) => {});
				}
			},
			addSupplierFn(url, param) {
				this.submitLoading = true;

				this.axios
					.post(this.getApiUrl(url), param, { toJSON: true })
					.then((res) => {
						this.submitLoading = false;
						if (res.code === 1) {
							this.$message.success("操作成功");
							this.dialogVisibleAdd = false;
							this.getData();
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.submitLoading = false;
					});
			},

			toCloseDialog() {
				this.dialogVisibleAdd = false;
				this.formData = {
					id: "",
					providerId: "",
					providerDto: {},
					branchId: "",
					userId: "",
					timeRate: "",
					serviceRate: "",
					attitudeRate: "",
					badRate: "",
					badReason: "",
				};
			},
			/**
			 * 新建、查看、修改角色 相关结束 -------**/
		},
		clrearTipid() {
			this.searchBox.providerRateId = "";
		},
		beforeRouteEnter(to, from, next) {
			if (from.name != "ServiceManager" && from.name != "WebsiteManager") {
				next((vm) => {
					vm.$root.breadList = [
						{ name: "供应商", link: "" },
						{ name: "供应商评价", link: "" },
					];
					vm.searchBox = {
						providerName: "", // 模糊查询
						status: "", // 状态
						pageNo: 1, // 页码
						providerRateId: to.params.id,
						pageSize: 10,
					};
					vm.getData();
					vm.listenWindow();
				});
			} else {
				next((vm) => {
					vm.$root.breadList = [
						{ name: "供应商", link: "" },
						{ name: "供应商评价", link: "" },
					];
					vm.getData();
					vm.listenWindow();
				});
			}
		},
		beforeRouteLeave(to, from, next) {
			if (to.name != "ServiceManager" && to.name != "WebsiteManager") {
				this.searchBox = {
					providerName: "", // 模糊查询
					status: "", // 状态
					pageNo: 1, // 页码
					pageSize: 10,
				};
				this.getData();
				to.meta.keepAlive = false;
			}

			next(true);
		},
	};
</script>

<style lang="scss" scoped type="text/scss">
	@import "@/assets/css/color.scss";
	.tipTime {
		display: flex;
		justify-content: space-between;
	}
	.tipFont {
		color: rgb(217, 0, 27);
	}
	.title {
		height: 30px;
		line-height: 30px;
		margin: 10px 0;
		font-weight: bold;
		padding-left: 20px;
		position: relative;
		&::before {
			content: "";
			display: block;
			position: absolute;
			left: 0;
			top: 5px;
			height: 18px;
			width: 8px;
			background-color: $theme;
		}
	}
	.no-a {
		color: #fff;
		text-decoration: none;
	}

	.el-message-box_style {
		.el-message-box__title {
			color: #f56c6c !important;
		}
	}
	.el-tooltip__popper {
		max-width: 200px;
	}
</style>
